{
  "hero": {
    "title": "Design.Make.Deliver."
  },
  "cta-contact": "Have a project in mind? Get in touch!",
  "hook": "Designing stories that connect — through video, photography, and digital experiences.",
  "industry": {
    "title": "Media Solutions for Your Industry",
    "options": {
      "ecommerce": "E-commerce Businesses",
      "restaurants": "Restaurants & Cafes",
      "retail": "Retail Stores",
      "salons": "Salons & Spas",
      "fitness": "Fitness Centers & Gyms",
      "realestate": "Real Estate Agencies",
      "professional": "Professional Services",
      "homeservices": "Home Services"
    }
  },
  "benefits": {
    "title": "10 points why Video content is good for your business:",
    "items": {
      "1": {
        "title": "1. Boost Engagement:",
        "text": "Videos capture attention faster than any other medium, increasing engagement on your website and social media platforms."
      },
      "2": {
        "title": "2. Tell Your Story:",
        "text": "Showcase your brand's unique identity, values, and products in a compelling, visual way that resonates with your audience."
      },
      "3": {
        "title": "3. Increase Conversions:",
        "text": "A well-crafted video can drive more leads and sales by clearly explaining your offerings and building trust with potential customers."
      },
      "4": {
        "title": "4. Expand Reach:",
        "text": "Video content is highly shareable, helping your message reach a broader audience across multiple platforms."
      },
      "5": {
        "title": "5. Enhance SEO:",
        "text": "Videos improve search engine rankings by increasing time spent on your website and driving more organic traffic."
      },
      "6": {
        "title": "6. Simplify Complex Ideas:",
        "text": "Use animations or explainer videos to make intricate concepts easy to understand for your customers."
      },
      "7": {
        "title": "7. Strengthen Brand Recall:",
        "text": "People are more likely to remember your brand after watching a video compared to reading text alone."
      },
      "8": {
        "title": "8. Build Emotional Connections:",
        "text": "Video storytelling creates deeper connections with your audience, fostering loyalty and trust."
      },
      "9": {
        "title": "9. Adapt to Modern Trends:",
        "text": "With video being the preferred content format for consumers, staying competitive means embracing this powerful medium."
      },
      "10": {
        "title": "10. Showcase Professionalism:",
        "text": "High-quality video production reflects your company's commitment to excellence and attention to detail."
      }
    }
  },
  "services": {
    "title": "Services",
    "subtitle": "Per Project or Subscription",
    "tagline": "Choose the flexibility that fits your needs!",
    "description": "With Per Project Services, you get a tailored solution for one-time video production, perfect for presentations, promotional campaigns, or special events. If you're looking for consistent, ongoing support, our Monthly Subscription provides regular, high-quality video content to keep your brand fresh and engaging across platforms. Both options include professional guidance, creative storytelling, and optimization for modern audiences.",
    "cta": "Get in touch"
  },
  "gear": {
    "title": "I use professional gear",
    "items": [
      "Panasonic GH7",
      "Olympus EM-III",
      "Elgato prompter",
      "Peak Design",
      "Rode",
      "and more"
    ]
  },
  "software": {
    "title": "I use professional software"
  },
  "comparison": {
    "title": "The Old Way",
    "titleKhromatik": "The Khromatik Way",
    "items": [
      {
        "old": "Hiring 3 different freelancers who don't talk to each other.",
        "khromatik": "One partner who understands the code, the design, and the lens."
      },
      {
        "old": "Beautiful website filled with generic stock photos.",
        "khromatik": "Custom content shot specifically for your layout and your users."
      },
      {
        "old": "Junior designers learning on your budget.",
        "khromatik": "20 years of seniority applied to every pixel and every frame."
      }
    ]
  }
}
